module.exports = __webpack_public_path__ + "img/fondo.1a9736e5.png";